{
  "title": "Feather Fall",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 reaction, which you take when you or a creature within 60 feet of you falls",
  "range": "60 feet",
  "components": "V, M (a small feather or piece of down)",
  "duration": "1 minute",
  "description": [
    "Choose up to five falling creatures within range. A falling creature’s rate of descent slows to 60 feet per round until the spell ends. If the creature lands before the spell ends, it takes no falling damage and can land on its feet, and the spell ends for that creature."
  ],
  "spellLists": ["artificer", "bard", "sorcerer", "wizard"]
}
